// extracted by mini-css-extract-plugin
export default {"openText":"style_openText__kcFXv","question":"style_question__kq6XH"};